import givehub from "../assets/GiveHub.png";
import ppmn from "../assets/2PM&.jpg";
import pp from "../assets/PP_Library.png";
import todo from "../assets/TickIt.svg";
import twinkle from "../assets/Twinkle.png";
import af from "../assets/AF.png";

export const projects = [
  {
    id: 1,
    title: "GiveHub",
    category: "Web",
    image: givehub,
    link: "https://github.com/Solarnenene147/GiveHub",
    desc: "Volunteering is a priceless gift you can give.",
  },
  {
    id: 2,
    title: "2PM& Fruitables",
    category: "Web",
    image: ppmn,
    link: "https://github.com/nhsmai04/IS207-SOLITEA",
    desc: "A fruit-ordering website for healthy living.",
  },
  {
    id: 3,
    title: "PP Library",
    category: "App",
    image: pp,
    link: "https://github.com/phu3112004/IE307-Mobile/tree/master/Project",
    desc: "A mobile application for people who want to read online books free!",
  },
  {
    id: 4,
    title: "TickIt",
    category: "Web",
    image: todo,
    link: "https://github.com/Solarnenene147/todo_list",
    desc: "Fast, simple, beautiful. Managing your tasks has never been easier",
  },
  {
    id: 5,
    title: "Twinkle",
    category: "Design",
    image: twinkle,
    link: "https://www.figma.com/proto/5v7nSTcf4oqXJQm9kQ7sKi/UI-UX-%C4%90%E1%BB%92-%C3%81N?node-id=1119-13272&starting-point-node-id=1119%3A13272&t=zlojkEJqFUh4Fc7p-1",
    desc: "A design project focused on creating a sparkle dating app for illustrators.",
  },
  {
    id: 6,
    title: "AF Finance",
    category: "Web",
    image: af,
    link: "https://finance-af.vercel.app/",
    desc: "A financial web that helps users manage cash flow, using Supabase instead of a traditional backend.",
  },
  {
    id: 7,
    title: "AF Finance",
    category: "App",
    image: af,
    link: "https://www.dropbox.com/scl/fi/kobjt9azirs8eh4pqzxzp/AF-Finance.apk?rlkey=7hdsnup1ge9457qvndqlivux0&st=zi5ry272&dl=0",
    desc: "A financial mobile app that helps users manage cash flow, using Supabase instead of a traditional backend.",
  },
];
